import { NGXLogger } from 'ngx-logger';
import { element } from 'protractor';
import { Component, OnInit, Input, EventEmitter } from '@angular/core';
import { Observable } from 'rxjs';
import { Proposal } from 'src/app/models/proposal';
import { ProposalImage } from 'src/app/models/proposal-image';
import { ActivatedRoute } from '@angular/router';
import { CreateProposalDTO } from 'src/app/models/createproposaldto';
import cloneDeep from 'lodash/cloneDeep';
import { Output} from '@angular/core';
import { DataService } from 'src/app/services/data.service';
import { DatePipe } from '@angular/common';
import { ProposalDocument } from 'src/app/models/proposal-document';
import Calculator from 'src/app/core/utility/calculator';
import { AppSettings } from 'src/app/app.settings';
import Helper from 'src/app/core/utility/helper';
import { MatTabChangeEvent } from '@angular/material';
import { ProposalService } from 'src/app/services/proposal.service';
import { UnitOfMeasurement } from 'src/app/models/internal/unit-of-measurement';
import { Constants } from 'src/app/core/constants';
import { RejectionReason } from 'src/app/models/rejection-reason';
import { LocalstorageService } from 'src/app/services/localstorage.service';
import { BasePage } from 'src/app/core/basepages/allbasepages';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { PackageTemplateFile } from 'src/app/models/package-template-file';
import { ProposalEstimate } from 'src/app/models/proposal-estimate';
import { ReassignPeComponent } from 'src/app/pe/package-engineer-assignment/reassign-pe/reassign-pe.component';
import { MatDialog } from '@angular/material/dialog';
import { ProposalLocation } from '../../models/internal/proposal-location';
@Component({
    selector: 'app-proposal-details',
    templateUrl: './proposal-details.component.html',
    styleUrls: ['./proposal-details.component.scss'],
})
export class ProposalDetailsComponent extends BasePage implements OnInit {
    @Input() showCloseWindowButton: boolean = true;
    @Input() parentPage: string;
    @Output() public proposalLoaded: EventEmitter<Proposal> = new EventEmitter<Proposal>();
    globalUOM: UnitOfMeasurement = new UnitOfMeasurement();
    IsEmployee: boolean;
    IsSupplier: boolean;
    IsLoggedInAsSupplier: boolean;
    IsEmployee$: Observable<boolean>;
    IsSupplier$: Observable<boolean>;
    proposalId: string;
    proposalDTO: Proposal;
    partImages: ProposalImage[] = [];
    packageImages: ProposalImage[] = [];
    packageDocuments: ProposalDocument[] = [];
    testingDocuments: ProposalDocument[] = [];
    proposalEstimate: ProposalEstimate[] = [];
    selectedTabIndex: number = 0;
    lowUtilizationThreshold: number;
    pipe = new DatePipe('en-US');
    rejectionReasons = [];
    primaryArray = [];
    secondaryArray = [];
    tertiaryArray = [];
    missingPartImages = [
        [1,1 , "assets/images/placeholders/part_1.jpg", "Iso-View", ""],//Iso-View
        [1,2 , "assets/images/placeholders/part_2.jpg", "Iso-View (Opposite Side)", ""]//Iso-View (Opposite Side)
    ];

    missingPackageImages = [
        [2,3, "assets/images/placeholders/package_1.jpg", "Open Box with Parts & Dunnage", "Primary Level" ],//Primary level Open Box with Parts & Dunnage
        [2,4, "assets/images/placeholders/package_2.jpg", "Iso-View", "Primary Level"],//Primary Iso-View
        [2,5, "assets/images/placeholders/package_3.jpg", "Iso-View", "Secondary Level" ],//Secondary Iso-View
        [2,6, "assets/images/placeholders/package_3.jpg", "Iso-View", "Tertiary Level"],//Tertiary Iso-View
        [2,7, "assets/images/placeholders/package_4.jpg","Empty Pallet/Container","Empty Pallet"]//EmptyPallet/Container
    ];

    constructor(
        appSettings: AppSettings,
        logger: NGXLogger,
        localstorageService: LocalstorageService,
        private readonly route: ActivatedRoute,
        private dataService: DataService,
        private proposalService: ProposalService,
        private matDialog: MatDialog
    ) {
        super(localstorageService, logger, appSettings);
    }

    isNewImageProcess() {
        if(this.proposalDTO) {
             if(this.proposalDTO.CreatedOn >= new Date('2024-11-12')) {
                return true;
             }

             //this means one of the images has a category therefore supplier/pe should submit all images under the right category
             if(this.proposalDTO.ImageInfo.filter(i => i.Category > 0).length) {
                return true;
             }
        }
        return false;
    }

    ngOnInit() {
        this.IsEmployee =
            this.localstorageService.retrieve(
                Constants.localStorageKeys.IsEmployee
            ) === Constants.IsEmployeeCheckCode;
        this.IsLoggedInAsSupplier =
            this.localstorageService.retrieve(
                Constants.localStorageKeys.IsLoggedInAsSupplier
            ) === Constants.IsLoggedAsSupplierSecurityKey;
        this.getLowUtilizationThreshold();
        this.route.paramMap.subscribe((params) => {
            this.proposalId = params.get('id');
            if (this.proposalId) {
                this.getProposal(this.proposalId);
            }
        });

        this.proposalService.proposalTabsSelectedIndex.subscribe((index) => {
            this.selectedTabIndex = index;
        });
        this.proposalService.proposalEstimate.subscribe((estimate) => {
            this.proposalEstimate = estimate;
        });
    }
    getLowUtilizationThreshold() {
        this.dataService
            .getAppSettingsByKey('LowUtilizationThreshold')
            .subscribe((response: any) => {
                if (
                    response.Success &&
                    response.Data &&
                    response.Data.ParameterValue
                ) {
                    this.lowUtilizationThreshold = response.Data.ParameterValue;
                }
            });
    }

    isLowLogisticsUtilization() {
        if (!this.proposalDTO ||
            !this.proposalDTO.CubeUtilization ||
            !this.proposalDTO.WeightUtilization ||
            this.proposalDTO.CubeUtilization == 0 ||
            this.proposalDTO.WeightUtilization == 0
        )
            return false;

        return this.proposalDTO.CubeUtilization < this.lowUtilizationThreshold && this.proposalDTO.WeightUtilization < this.lowUtilizationThreshold;
    }
    reassignPEInfo() {
        var currentPEAssignments = this.getSelectedPEAssignments();
        const dialogRef = this.matDialog.open(ReassignPeComponent, {
            height: '600px',
            width: '1000px',
            data: currentPEAssignments,
        });
        dialogRef.afterClosed().subscribe((result) => {
            this.proposalDTO = null;
            this.getProposal(this.proposalId);
        });
    }
    getSelectedPEAssignments() {
        var sourceTypeId = this.proposalDTO.PackageInfo.SourceTypeIds[0];
        var partNumber = this.proposalDTO.PartInfo.Parts[0].PartNumber;
        var partCategory = this.proposalDTO.PartInfo.Parts[0];
        var sourceTypeDescription =
            this.proposalDTO.PackageInfo.SourceTypes.find(
                (x) => x.Id == sourceTypeId
            ).SourceTypeDescription;
        var engineerUserName = this.proposalDTO.AssignedEngineerUserName;
        if (engineerUserName == null || engineerUserName == '')
            engineerUserName = this.proposalDTO.EngineerUserName;
        return [
            {
                SourceTypeDescription: sourceTypeDescription,
                SourceTypeId: sourceTypeId,
                PartCategoryId: partCategory.PartCategoryId,
                PartCategoryDescription: partCategory.PartCategoryDescription,
                EngineerUserName: engineerUserName,
                PartNumber: partNumber.substring(0, 7),
                ReassignFromDetailsScreen: true,
            },
        ];
    }
    /**
     *  TMS-14254 Flag to PE when new submitted proposal for an existing part does not match the last approved proposal
     */
    getProposal(id: string) {
        if (!this.proposalDTO) {
            if (this.IsEmployee && !this.IsLoggedInAsSupplier) {
                this.dataService
                    .getProposalForReview(id)
                    .subscribe((response: any) => {
                        this.proposalDTO = cloneDeep(response.Data);
                        this.processProposal(this.proposalDTO);
                    });
                this.getPackageTemplateFileInfo(id);
            } else {
                this.dataService.getProposal(id).subscribe((response: any) => {
                    this.proposalDTO = cloneDeep(response.Data);
                    this.processProposal(this.proposalDTO);
                    this.getPackageTemplateFileInfo(id);
                });
            }
        }
    }

    getPackageTemplateFileInfo(id) {
        this.dataService
            .getPackageTemplateFileInfo(id)
            .subscribe((response: any) => {
                this.primaryArray = response.filter(
                    (r) => r.PackageLevelId == Constants.PRIMARY_LEVEL
                );
                this.secondaryArray = response.filter(
                    (r) => r.PackageLevelId == Constants.SECONDARY_LEVEL
                );
                this.tertiaryArray = response.filter(
                    (r) => r.PackageLevelId == Constants.TERTIARY_LEVEL
                );
            });
    }

    processProposal(proposal: Proposal) {
        if (!proposal) {
            this.proposalLoaded.next(null);
            return;
        }
        const fullProposalDTO = new CreateProposalDTO();
        fullProposalDTO.DefaultProposal = proposal;

        const levels = proposal.PackageInfo.ProposalPackageLevels;
        if (levels) {
            if(levels.length < 3) {
                this.missingPackageImages = this.missingPackageImages.filter(item => !(item[0] == 2 && item[1] == 6));
            }

            if(levels.length < 2) {
                this.missingPackageImages = this.missingPackageImages.filter(item => !(item[0] == 2 && item[1] == 5));
            }
        }
        // Set CreateProposalDto in Proposal Service for Communications Tab to access it.
        this.proposalService.RefreshCreateProposalDTO(fullProposalDTO);
        this.updateUOM(proposal.PackageInfo.UOMSystemId);
        if (proposal.ImageInfo && proposal.ImageInfo.length > 0) {
            this.partImages = proposal.ImageInfo.filter((a) => a.Type == 1);
            this.partImages.forEach((x) => {

                var m = this.missingPartImages;

                m = m.filter(item => !(item[0] == x.Type && item[1] == x.Category));

                this.missingPartImages = m;

                this.dataService
                    .getImageFile(x.Id.toString())
                    .subscribe((y: any) => {
                        if (y['Success'] == true) {
                            const extension = this.getFileExtensions(y);
                            if (extension.length === 0) {
                                return;
                            }
                            if (extension.length >= 2) {
                                x.DisplayUrl =
                                    'data:image/' +
                                    extension[extension.length - 1] +
                                    ';base64,' +
                                    y['Data']['Base64String'];
                            } else {
                                x.DisplayUrl =
                                    'data:image/png' +
                                    ';base64,' +
                                    y['Data']['Base64String'];
                            }
                        }
                    });
            });
            this.packageImages = proposal.ImageInfo.filter((a) => a.Type == 2);
            this.packageImages.forEach((x) => {

                var m = this.missingPackageImages;

                m = m.filter(item => !(item[0] == x.Type && item[1] == x.Category));

                this.missingPackageImages = m;

                this.dataService
                    .getImageFile(x.Id.toString())
                    .subscribe((y: any) => {
                        if (y['Success'] == true) {
                            const extension = this.getFileExtensions(y);
                            if (extension.length === 0) {
                                return;
                            }
                            if (extension.length >= 2) {
                                x.DisplayUrl =
                                    'data:image/' +
                                    extension[extension.length - 1] +
                                    ';base64,' +
                                    y['Data']['Base64String'];
                            } else {
                                x.DisplayUrl =
                                    'data:image/png' +
                                    ';base64,' +
                                    y['Data']['Base64String'];
                            }
                        }
                    });
            });
        }

        if (proposal.DocumentInfo && proposal.DocumentInfo.length > 0) {
            this.packageDocuments = proposal.DocumentInfo.filter(
                (a) => a.Type == 1
            );
            this.testingDocuments = proposal.DocumentInfo.filter(
                (a) => a.Type == 2
            );
        }
        this.proposalLoaded.next(proposal);
    }

    updateUOM(packageUomId: number) {
        this.globalUOM = Helper.getUoMObject(packageUomId);
        // this.updateMeasurementsOnLoad();
    }

    // get file extensions
    getFileExtensions(response: any) {
        if (
            response &&
            response['Success'] == true &&
            response['Data'] &&
            response['Data']['FileName']
        ) {
            return String(response['Data']['FileName']).split('.');
        }

        return [];
    }

    getImageURL(image: ProposalImage) {
        // this.logDebug(image.Url + 'contains version = ' + image.Url.includes("/version/"));
        // return this.appSettings.WarpStorageAPIImageBaseUrl + '/' + this.proposalId + '/file/' + image.Url;

        if (
            image.DisplayUrl == undefined ||
            image.DisplayUrl == null ||
            image.DisplayUrl === ''
        ) {
            return image.UUId;
        } else {
            return image.DisplayUrl;
        }
    }

    getRejectionReasonDescriptions(rejectionReasonList: RejectionReason[]) {
        let rejectionReasons = '';
        rejectionReasonList.forEach((x) => {
            rejectionReasons += x.Description + ',';
        });
        return rejectionReasons;
    }

    checkIfRejectionReasonsExist() {
        // this.proposalDTO.PackageInfo.RejectionReason = this.proposalDTO.PackageInfo.RejectionReason.filter(x => x.Description !== 'Other');
        if (
            this.proposalDTO.PackageInfo.RejectionReason &&
            this.proposalDTO.PackageInfo.RejectionReason.length > 0
        ) {
            const rejectionInfo = Helper.fillRejectionInfo(this.proposalDTO);
            if (rejectionInfo.length > 0) {
                this.rejectionReasons =
                    rejectionInfo[0].RejectionReasons.split(',');
            }
        }
        return (
            this.proposalDTO.PackageInfo.RejectionReason.filter(
                (x) => x.Description !== 'Other'
            ).length > 0
        );
    }

    checkIfReviewProposal() {
        return (
            this.proposalDTO.EngineerUserName != null &&
            this.proposalDTO.PackageInfo.WorkflowStatusId !=
                Constants.WORKFLOW_STATUS_NEW &&
            this.proposalDTO.PackageInfo.WorkflowStatusId !=
                Constants.WORKFLOW_STATUS_SUBMITTED
        );
    }

    shouldShowConditionalApprovalField() {
        return (
            this.proposalDTO.PackageInfo.WorkflowStatusId !=
                Constants.WORKFLOW_STATUS_NEW &&
            this.proposalDTO.PackageInfo.WorkflowStatusId !=
                Constants.WORKFLOW_STATUS_SUBMITTED
        );
    }

    getEffectivityFrom() {
        if (this.proposalDTO && this.proposalDTO.PackageInfo) {
            return Helper.formatDate(
                this.proposalDTO.PackageInfo.ProposalEffectivity.EffectiveFrom
            );
        } else {
            return '';
        }
    }

    getEffectivityTo() {
        if (this.proposalDTO && this.proposalDTO.PackageInfo) {
            return Helper.formatDate(
                this.proposalDTO.PackageInfo.ProposalEffectivity.EffectiveTo
            );
        } else {
            return '';
        }
    }

    //tms-37161 show effective to date only when proposal is conditionally approved
    getConditionallyApprovedTill() {
        if (
            this.proposalDTO &&
            this.proposalDTO.PackageInfo &&
            this.proposalDTO.PackageInfo.IsConditionalApproval &&
            this.proposalDTO.PackageInfo.WorkflowStatusId ==
                Constants.WORKFLOW_STATUS_APPROVED
        ) {
            return Helper.formatDate(
                this.proposalDTO.PackageInfo.ProposalEffectivity.EffectiveTo
            );
        } else {
            return 'N/A';
        }
    }
    getTotalWeight(level: number) {
        const primaryPackageLevel =
            this.proposalDTO.PackageInfo.ProposalPackageLevels[0];
        const secondaryPackageLevel =
            this.proposalDTO.PackageInfo.ProposalPackageLevels[1];
        const tertiaryPackageLevel =
            this.proposalDTO.PackageInfo.ProposalPackageLevels[2];
        const partWeight = Helper.calculateDim(
            this.proposalDTO.PartInfo.Weight,
            this.globalUOM,
            true
        );
        const primaryTotalWeight = Calculator.GetTotalWeight_Primary(
            primaryPackageLevel.QPC,
            partWeight,
            Helper.calculateDim(
                primaryPackageLevel.TareWeight,
                this.globalUOM,
                true
            )
        );
        let secondaryTotalWeight = null;
        if (secondaryPackageLevel) {
            secondaryTotalWeight = Calculator.GetTotalWeight_Secondary(
                primaryTotalWeight,
                secondaryPackageLevel.ContainersPerLayer,
                secondaryPackageLevel.NoOfLayers,
                Helper.calculateDim(
                    secondaryPackageLevel.TareWeight,
                    this.globalUOM,
                    true
                )
            );
        }

        if (this.proposalDTO && this.proposalDTO.PackageInfo) {
            switch (level) {
                case 1: {
                    return primaryTotalWeight;
                    break;
                }
                case 2: {
                    return secondaryTotalWeight;
                    break;
                }
                case 3: {
                    if (tertiaryPackageLevel) {
                        return Calculator.GetTotalWeight_Tertiary(
                            secondaryTotalWeight,
                            tertiaryPackageLevel.ContainersPerLayer,
                            tertiaryPackageLevel.NoOfLayers,
                            Helper.calculateDim(
                                tertiaryPackageLevel.TareWeight,
                                this.globalUOM,
                                true
                            )
                        );
                    } else {
                        return null;
                    }
                    break;
                }
            }
        }
    }
    getTotalContainerQuantity(level: number) {
        if (this.proposalDTO && this.proposalDTO.PackageInfo) {
            const primaryPackageLevel =
                this.proposalDTO.PackageInfo.ProposalPackageLevels[0];
            const secondaryPackageLevel =
                this.proposalDTO.PackageInfo.ProposalPackageLevels[1];
            const tertiaryPackageLevel =
                this.proposalDTO.PackageInfo.ProposalPackageLevels[2];
            const primaryTotalContainerQuantity = 0;
            let secondaryTotalContainerQuantity = null;
            if (secondaryPackageLevel) {
                secondaryTotalContainerQuantity =
                    Calculator.GetTotalContainerQuantity_Secondary(
                        secondaryPackageLevel.ContainersPerLayer,
                        secondaryPackageLevel.NoOfLayers
                    );
            }
            switch (level) {
                case 1: {
                    return primaryTotalContainerQuantity;
                    break;
                }
                case 2: {
                    return secondaryTotalContainerQuantity;
                    break;
                }
                case 3: {
                    if (tertiaryPackageLevel) {
                        return Calculator.GetTotalContainerQuantity_Tertiary(
                            secondaryTotalContainerQuantity,
                            tertiaryPackageLevel.ContainersPerLayer,
                            tertiaryPackageLevel.NoOfLayers
                        );
                    } else {
                        return null;
                    }
                    break;
                }
            }
        }
    }

    getDeviationClass(current: number, estimate: number): string {
        if (estimate === 0 || current === estimate) return 'boldValue';
        const deviation = Math.abs((current - estimate) / estimate) * 100;
        return deviation <= 25 ? 'diff-warning' : 'diff-error';
    }

    getTotalPartQuantity(level: number) {
        if (this.proposalDTO && this.proposalDTO.PackageInfo) {
            const primaryPackageLevel =
                this.proposalDTO.PackageInfo.ProposalPackageLevels[0];
            const secondaryPackageLevel =
                this.proposalDTO.PackageInfo.ProposalPackageLevels[1];
            const tertiaryPackageLevel =
                this.proposalDTO.PackageInfo.ProposalPackageLevels[2];

            let primaryQPC = Calculator.GetTotalPartQuantity_Primary(
                primaryPackageLevel.QPC
            );
            let secondaryQPC = secondaryPackageLevel
                ? Calculator.GetTotalPartQuantity_Secondary(
                      primaryQPC,
                      secondaryPackageLevel.ContainersPerLayer,
                      secondaryPackageLevel.NoOfLayers
                  )
                : 0;
            let tertiaryQPC = tertiaryPackageLevel
                ? Calculator.GetTotalPartQuantity_Tertiary(
                      secondaryQPC,
                      tertiaryPackageLevel.ContainersPerLayer,
                      tertiaryPackageLevel.NoOfLayers
                  )
                : 0;

            let estimate =
                this.proposalEstimate && this.proposalEstimate.length >= level
                    ? this.proposalEstimate[level - 1]
                    : null;

            let currentQPC = 0;
            let currentClass = '';
            let currentEstimate = estimate ? (estimate.QPC as number) : 0;
            switch (level) {
                case 1: {
                    currentQPC = primaryQPC;
                    break;
                }
                case 2: {
                    currentQPC = secondaryQPC;
                    break;
                }
                case 3: {
                    currentQPC = tertiaryQPC;
                    break;
                }
            }
            currentClass = this.getDeviationClass(currentQPC, currentEstimate);
            let res = {
                tooltip:
                    currentEstimate > 0
                        ? `Tesla Estimate QPC: ${currentEstimate}`
                        : null,
                class: currentClass,
                QPC: currentQPC,
            };
            return res;
        }
    }

    getPackageInfoPropValue(levelIndex: number, propName: string) {
        const level =
            this.proposalDTO.PackageInfo.ProposalPackageLevels[levelIndex];
        if (level) {
            if (propName == 'DunnageType') {
                let tempstringdunnagetype = '';
                if (level) {
                    if (level.proposalPackageLevelDunnageTypes) {
                        level.proposalPackageLevelDunnageTypes.forEach((x) => {
                            if (x.Description != 'Other') {
                                tempstringdunnagetype += ' ' + x.Description;
                            }
                        });
                    }
                    if (level[propName]) {
                        tempstringdunnagetype += ' ' + level[propName];
                    }
                }
                return tempstringdunnagetype;
            } else {
                return level[propName];
            }
        } else {
            return '';
        }
    }

    getDims(levelIndex: number) {
        if (
            !this.proposalDTO ||
            !this.proposalDTO.PackageInfo ||
            !this.proposalDTO.PackageInfo.ProposalPackageLevels ||
            !this.proposalDTO.PackageInfo.ProposalPackageLevels[levelIndex]
        )
            return {
                dims: '',
                class: '',
                tooltip: null,
            };

        let length = Helper.calculateDim(
            this.getPackageInfoPropValue(levelIndex, 'Length'),
            this.globalUOM
        );
        let width = Helper.calculateDim(
            this.getPackageInfoPropValue(levelIndex, 'Width'),
            this.globalUOM
        );
        let height = Helper.calculateDim(
            this.getPackageInfoPropValue(levelIndex, 'Height'),
            this.globalUOM
        );

        let estimate =
            this.proposalEstimate && this.proposalEstimate.length > levelIndex
                ? this.proposalEstimate[levelIndex]
                : null;
        let currentClass = 'boldValue';
        let tooltip = null;

        if (estimate) {
            let estimateLength = estimate.PackageLength as number;
            let estimateWidth = estimate.PackageWidth as number;
            let estimateHeight = estimate.PackageHeight as number;
            let deviationClassList = [
                this.getDeviationClass(length, estimateLength),
                this.getDeviationClass(width, estimateWidth),
                // this.getDeviationClass(height, estimateHeight)
            ];
            if (deviationClassList.some((x) => x === 'diff-error'))
                currentClass = 'diff-error';
            else if (deviationClassList.some((x) => x === 'diff-warning'))
                currentClass = 'diff-warning';

            tooltip = `${estimateLength} (L) x ${estimateWidth} (W) x ${estimateHeight} (H)`;
        }

        let res = {
            dims: `${length} (L) x ${width} (W) x ${height} (H)`,
            class: currentClass,
            tooltip: `Tesla Estimate Dimensions: ${tooltip}`,
        };
        return res;
    }

    getStackability() {
        if (this.proposalDTO && this.proposalDTO.PackageInfo) {
            return this.proposalDTO.PackageInfo.IsStackable;
        } else {
            return false;
        }
    }

    getProposalStatus(statusId: number) {
        return Helper.getProposalStatusDescription(statusId);
    }

    getIsServiceOptimized(IsServiceOptimized: boolean | null) {
        if (IsServiceOptimized == null) {
            return 'N/A';
        }
        return IsServiceOptimized ? 'Yes' : 'No';
    }
    getDimValue(dim, uom: UnitOfMeasurement, isWeight = false) {
        return Helper.calculateDim(dim, uom, isWeight);
    }

    getSourceTypeDescription(dateItem: Proposal) {
        return dateItem.PackageInfo.SourceTypes.map(
            (x) => x.SourceTypeDescription
        ).join(', ');
    }

    getManufacturingLocationDescription(dateItem: Proposal) {
      const location2 = Object.assign(new ProposalLocation(), dateItem.ManufacturingLocation);
      return location2 ? location2.toString() : '';
    }

    getSecondaryProcessingLocationDescription(dateItem: Proposal) {
      const location2 = Object.assign(new ProposalLocation(), dateItem.SecondaryProcessingLocation);
      return location2 ? location2.toString() : '';
    }


  removeQuotes(rejectionComment: string) {
        const latestRejectionComment =
            Helper.latestRejectionComment(rejectionComment);
        return latestRejectionComment === undefined
            ? ''
            : latestRejectionComment;
    }

    UserUOMPref(event) {
        this.globalUOM = Helper.getUoMObject(event);
        this.updateMeansurements();
    }

    updateMeansurements() {
        this.proposalDTO.PackageInfo.ProposalPackageLevels.forEach((x) => {
            Helper.calculateDim(x.Length, this.globalUOM);
            Helper.calculateDim(x.Width, this.globalUOM);
            Helper.calculateDim(x.Height, this.globalUOM);
            Helper.calculateDim(x.TareWeight, this.globalUOM, true);
            Helper.calculateDim(x.MaxWeight, this.globalUOM, true);
        });
        Helper.calculateDim(this.proposalDTO.PartInfo.Length, this.globalUOM);
        Helper.calculateDim(this.proposalDTO.PartInfo.Width, this.globalUOM);
        Helper.calculateDim(this.proposalDTO.PartInfo.Height, this.globalUOM);
        Helper.calculateDim(
            this.proposalDTO.PartInfo.Weight,
            this.globalUOM,
            true
        );
    }

    setpercentagePackageUtilization(partInfo, proposalPackageLevelInfo) {
        const primaryPackageLevel =
            this.proposalDTO.PackageInfo.ProposalPackageLevels[0];
        const primaryQPC = Calculator.GetTotalPartQuantity_Primary(
            primaryPackageLevel.QPC
        );
        return Helper.getPercentagePackageUtilization(
            partInfo,
            proposalPackageLevelInfo,
            primaryQPC
        );
    }

    displaySubmissionInfoIfAlreadySubmitted() {
        return (
            this.proposalDTO.PackageInfo.WorkflowStatusId >
                Constants.WORKFLOW_STATUS_NEW ||
            this.checkIfRejectionReasonsExist() ||
            this.removeQuotes(this.proposalDTO.PackageInfo.RejectionComment) !=
                ''
        );
    }

    displayApprovalOrRejectionInfo() {
        return (
            this.proposalDTO.PackageInfo.WorkflowStatusId >
                Constants.WORKFLOW_STATUS_SUBMITTED ||
            this.checkIfRejectionReasonsExist() ||
            this.removeQuotes(this.proposalDTO.PackageInfo.RejectionComment) !=
                ''
        );
    }

    downloadAttachments(PackageTemplateFileId: number) {
        this.dataService
            .getAttachmentFile(PackageTemplateFileId.toString())
            .subscribe((response: any) => {
                Helper.downloadAttachments(
                    response['Data']['Base64String'],
                    response['Data']['FileName'],
                    'application/octet-stream;base64'
                );
            });
    }

    getImageDescription(image: ProposalImage) {
        return Helper.getImageDescription(image);
    }
}
